<div class="flex flex-col flex-1 px-3 py-2 max-w-5xl mx-auto w-full">
  <div class="flex items-center mb-3">
    <h1 class="text-base font-semibold">Settings</h1>
  </div>

  <!-- Tab bar -->
  <div role="tablist" class="tabs tabs-bordered mb-4">
    @for (t of tabs; track t.path) {
      <a
        role="tab"
        class="tab"
        [routerLink]="['/admin/settings', t.path]"
        routerLinkActive="tab-active font-semibold text-primary"
      >
        {{ t.label }}
      </a>
    }
  </div>

  <!-- Active tab -->
  <router-outlet></router-outlet>
</div>
